<template>
  <div class="mainCommonListContainer">
    <div class="buttonContainer">
      <div class="addDiv">
        <el-button @click="add()" v-if="null !== addPermission" class="addBtn"
          >{{ addPermission.name }}<i class="el-icon-plus el-icon--right"></i
        ></el-button>
      </div>
      <div id="queryDiv">
        <el-form :model="queryForm" @submit.native.prevent>
          <el-form-item label="">
            <el-input
              v-model="queryForm.name"
              placeholder="搜索机场名称"
              @keyup.enter.native="handleCurrentChange(1)"
              ><i
                class="el-icon-search"
                slot="suffix"
                @click="handleCurrentChange(1)"
              >
              </i
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="mainTableContainer">
      <el-table
        class="table"
        :data="tableData"
        height="491"
        style="width: 100%"
        ref="commonTable"
      >
        <el-table-column
          prop="name"
          label="名称"
          min-width="70"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="code3"
          label="三字码"
          min-width="40"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="longitude"
          label="经度(度)"
          min-width="60"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="latitude"
          label="纬度(度)"
          min-width="60"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="altitude"
          label="高度(米)"
          min-width="40"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="area_name"
          label="所属战区"
          min-width="60"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="station_name"
          label="所属站点"
          min-width="60"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="操作"
          min-width="60"
          align="center"
          v-if="buttonList.length !== 0"
        >
          <template slot-scope="scope">
            <div class="buttonCol">
              <div
                v-for="(button, index) in buttonList"
                :key="index"
                class="buttonClass"
              >
                <el-button
                  v-if="button.path === 'airportList-edit'"
                  @click="edit(scope.row)"
                  icon="el-icon-operte-view"
                  class="editBtn"
                  style="margin-right: 10px"
                  >{{ button.name }}</el-button
                ><el-button
                  v-else-if="button.path === 'airportList-del'"
                  @click="del(scope.row)"
                  icon="el-icon-operte-view"
                  class="delBtn"
                  style="margin-right: 10px"
                  >{{ button.name }}</el-button
                >
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div
        style="
          text-align: right;
          margin-top: 15px;
          margin-right: 0px;
          height: 40px;
        "
        id="pages"
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="current"
          :page-sizes="[6, 16, 24, 32]"
          :page-size="size"
          layout="total, sizes, prev, pager, next"
          :total="totalCount"
          popper-class="adminHomeSelect"
        ></el-pagination
        ><!-- , jumper -->
      </div>
    </div>

    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="420px"
      class="commonDialog"
    >
      <div class="dialog-header-separator"></div>
      <el-form
        :rules="rules"
        ref="commonForm"
        :model="commonForm"
        label-width="120px"
        @submit.native.prevent
      >
        <el-form-item prop="name" label="机场名称">
          <el-input
            v-model="commonForm.name"
            maxlength="50"
            placeholder="请输入机场名称"
            @keyup.enter.native="submit('commonForm')"
          ></el-input>
        </el-form-item>
        <el-form-item prop="code3" label="三字码">
          <el-input
            v-model="commonForm.code3"
            maxlength="3"
            placeholder="请输入三字码"
            @keyup.enter.native="submit('commonForm')"
          ></el-input>
        </el-form-item>
        <el-form-item prop="station_id" label="所属区域">
          <el-cascader
            v-model="commonForm.area_station"
            :options="options"
            :props="{ expandTrigger: 'hover', value: 'id', label: 'value' }"
            @change="handleChange"
            popper-class="adminHomeCascader"
          >
            <template slot-scope="{ data }">
              <span>{{ data.value }}</span>
            </template>
          </el-cascader>
        </el-form-item>
        <el-form-item
          label="经度(度)"
          prop="longitude"
          class="number-adjust-item"
          label-width="100px"
        >
          <div style="width: 100%; height: 40px; display: block">
            <el-button
              icon="el-icon-plus"
              @click="addPoint('longitude')"
            ></el-button>
            <el-input
              @keyup.enter.native="submit('commonForm')"
              v-model="commonForm.longitude"
              placeholder="请输入经度"
              maxlength="11"
            ></el-input>
            <el-button
              icon="el-icon-minus"
              @click="reducePoint('longitude')"
            ></el-button>
          </div>
        </el-form-item>
        <el-form-item
          label="纬度(度)"
          prop="latitude"
          class="number-adjust-item"
          label-width="100px"
        >
          <div style="width: 100%; height: 40px; display: block">
            <el-button
              icon="el-icon-plus"
              @click="addPoint('latitude')"
            ></el-button>
            <el-input
              @keyup.enter.native="submit('commonForm')"
              v-model="commonForm.latitude"
              placeholder="请输入纬度"
              maxlength="10"
            ></el-input>
            <el-button
              icon="el-icon-minus"
              @click="reducePoint('latitude')"
            ></el-button>
          </div>
        </el-form-item>
        <el-form-item
          label="高度(米)"
          prop="altitude"
          class="number-adjust-item"
          label-width="100px"
        >
          <div style="width: 100%; height: 40px; display: block">
            <el-button
              icon="el-icon-plus"
              @click="addPoint('altitude')"
            ></el-button>
            <el-input
              @keyup.enter.native="submit('commonForm')"
              v-model="commonForm.altitude"
              placeholder="请输入高度"
              maxlength="7"
            ></el-input>
            <el-button
              icon="el-icon-minus"
              @click="reducePoint('altitude')"
            ></el-button>
          </div>
        </el-form-item>
        <el-form-item class="formItemBtnRow">
          <el-button
            type="primary"
            @click="submit('commonForm')"
            class="confirmBtn"
            >确 定</el-button
          ><el-button @click="dialogVisible = false" class="cancelBtn"
            >取 消</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "airportList",
  props: ["menuId"],
  data() {
    var checkLgn = (rule, value, callback) => {
      if (value) {
        value = Number(value);
        var reg = /^-?\d+(\.\d{1,6})?$/;
        if (reg.test(value)) {
          if (180 < value) {
            callback(new Error("经度不能大于180~"));
          } else if (value < -180) {
            callback(new Error("经度不能小于-180~"));
          } else {
            callback();
          }
        } else {
          callback(new Error("经度小数位数不能超过六位~"));
        }
      } else {
        return callback(new Error("经度不能为空~"));
      }
    };
    var checkLat = (rule, value, callback) => {
      if (value) {
        value = Number(value);
        var reg = /^-?\d+(\.\d{1,6})?$/;
        if (reg.test(value)) {
          if (90 < value) {
            callback(new Error("纬度不能大于90~"));
          } else if (value < -90) {
            callback(new Error("纬度不能小于-90~"));
          } else {
            callback();
          }
        } else {
          callback(new Error("纬度小数位数不能超过六位~"));
        }
      } else {
        return callback(new Error("纬度不能为空~"));
      }
    };
    var checkAltitude = (rule, value, callback) => {
      if (value) {
        value = Number(value);
        var reg = /^-?\d+(\.\d{1,2})?$/;
        if (reg.test(value)) {
          if (8845 < value) {
            callback(new Error("高度不能大于8845米~"));
          } else if (value < -413) {
            callback(new Error("高度不能小于-413米~"));
          } else {
            callback();
          }
        } else {
          callback(new Error("高度小数位数不能超过两位~"));
        }
      } else {
        return callback(new Error("高度不能为空~"));
      }
    };
    var checkCode3 = (rule, value, callback) => {
      if (value) {
        let reg = /^[a-zA-Z]{3}$/;
        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error("请输入3位字母的三字码~"));
        }
      } else {
        callback();
      }
    };
    return {
      queryForm: {},
      title: "添加机场",
      addFlag: true,
      commonForm: {},
      current: 1, //当前页数
      size: 18, //显示几条
      totalCount: 0, //总条数
      tableData: [],
      dialogVisible: false,
      addPermission: null,
      buttonList: [],
      options: [],
      rules: {
        name: [{ required: true, message: "请输入机场名称~", trigger: "blur" }],
        code3: [{ required: false, validator: checkCode3, trigger: "blur" }],
        station_id: [
          { required: true, message: "请选择站点名称~", trigger: "blur" },
        ],
        longitude: [{ required: true, validator: checkLgn, trigger: "blur" }],
        latitude: [{ required: true, validator: checkLat, trigger: "blur" }],
        altitude: [
          { required: true, validator: checkAltitude, trigger: "blur" },
        ],
      },
      pointRange: {
        longitude: { min: -180, max: 180 },
        latitude: { min: -90, max: 90 },
        altitude: { min: -413, max: 8845 },
      },
    };
  },
  mounted() {
    this.setGutterWidth();
    this.query();
    this.buttonList = [];
    this.addPermission = null;
    this.$emit("getMenuList", this.menuId, 1, 0, this.getButtonList);
  },
  methods: {
    getButtonList(buttonList) {
      let menuId = this.menuId;
      for (
        let i = 0, len = buttonList.length;
        i < len && this.buttonList.length === 0;
        i++
      ) {
        let button = buttonList[i];
        if (button) {
          let children = button.children;
          if (children) {
            children.forEach((child) => {
              this.getChildren(child);
            });
          }
        }
      }
    },
    getChildren(item) {
      let menuId = item.id;
      let children = item.children;
      if (this.menuId === menuId) {
        let otherButton = [];
        for (let i = 0, len = children.length; i < len; i++) {
          let child = children[i];
          if (child) {
            if (child.path === "airportList-add") {
              this.addPermission = child;
            } else if (child.path !== "airportList-view") {
              otherButton.push(child);
            }
          }
        }
        this.buttonList = otherButton;
      } else {
        if (children) {
          children.forEach((child) => {
            this.getChildren(child);
          });
        }
      }
    },
    callOnTabSelect() {
      this.$nextTick(function () {
        this.$refs.commonTable.doLayout();
      });
    },
    resetStation(data) {
      if (!this.isEmptyArray(data)) {
        data.forEach((element) => {
          if (!this.isEmptyArray(element.children)) {
            element.children.forEach((e) => {
              e.id = e.id;
              e.value = e.name;
            });
          }
        });
      }
      return data;
    },
    handleChange(selectInfo) {
      if (null == selectInfo) {
        return;
      }
      this.$data.commonForm.station_id = selectInfo[1];
    },
    addPoint(type) {
      this.addOrReducePoint(type, true);
    },
    reducePoint(type) {
      this.addOrReducePoint(type, false);
    },
    add() {
      this.$data.title = "添加机场";
      this.queryAllArea();
      this.$data.addFlag = true;
      this.$data.dialogVisible = true;
    },
    addAirport() {
      let vue = this;
      this.postJsonRequest(
        "/basic-info-server/airport/addAirPort.do",
        this.$data.commonForm
      )
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            vue.$data.dialogVisible = false;
            vue.query();
            vue.$message({
              message: "提交成功",
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () {},
            });
          } else if (res.code != 401) {
            let msg = "请求失败";
            if (null != res) {
              msg = res.msg;
            }
            let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            this.$confirm(tips, "提示", {
              confirmButtonText: "好的",
              customClass: "customClass-style",
              iconClass: "",
              dangerouslyUseHTMLString: true,
              confirmButtonClass: "confirm-style",
              showCancelButton: false,
            });
          }
        })
        .catch((error) => {});
    },
    queryAllArea() {
      let vue = this;
      this.getRequest("/basic-info-server/station/getStationGroupByArea.do")
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            if (!this.isEmptyArray(res.data)) {
              this.$data.options = this.resetStation(res.data);
            } else {
              this.$data.options = [];
            }
          } else if (res.code != 401) {
            // let msg = "请求数据失败";
            // if (!this.isEmptyStr(res.msg)) {
            //   msg = res.msg;
            // }
            // let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        })
        .catch((error) => {});
    },
    query() {
      let vue = this;
      this.getRequest(
        "/basic-info-server/airport/getAirPortList.do?pagesize=" +
          this.$data.size +
          "&currentpage=" +
          this.$data.current +
          this.getQueryParam()
      )
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            if (null != res.data && !this.isEmptyArray(res.data.list)) {
              this.$data.totalCount = res.data.total;
              this.$data.tableData = res.data.list;
            } else {
              this.$data.totalCount = 0;
              this.$data.tableData = [];
            }
          } else if (res.code != 401) {
            // let msg = "请求数据失败";
            // if (!this.isEmptyStr(res.msg)) {
            //   msg = res.msg;
            // }
            // let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        })
        .catch((error) => {});
    },
    //编辑
    edit(row) {
      this.doEdit(row.id);
    },
    doEdit(id) {
      let vue = this;
      this.postJsonRequest("/basic-info-server/airport/getAirPortById.do", {
        id: id,
      })
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            if (null != res.data) {
              this.$data.title = "修改机场";
              this.queryAllArea();
              this.$data.addFlag = false;
              if (res.data.area_id && res.data.station_id) {
                res.data.area_station = [
                  parseInt(res.data.area_id),
                  parseInt(res.data.station_id),
                ];
              }
              this.$data.commonForm = res.data;
              this.$data.dialogVisible = true;
            } else {
              // let tips =
              //   "<i class='el-icon-warn-tip'></i> 啊哦,请求数据不存在~";
              // this.$confirm(tips, "提示", {
              //   confirmButtonText: "好的",
              //   customClass: "customClass-style",
              //   iconClass: "",
              //   dangerouslyUseHTMLString: true,
              //   confirmButtonClass: "confirm-style",
              //   showCancelButton: false,
              // });
            }
          } else if (res.code != 401) {
            // let msg = "请求数据失败";
            // if (!this.isEmptyStr(res.msg)) {
            //   msg = res.msg;
            // }
            // let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        })
        .catch((error) => {});
    }, //编辑提交
    editAirport() {
      let vue = this;
      this.postJsonRequest(
        "/basic-info-server/airport/upateAirPort.do",
        this.$data.commonForm
      )
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            vue.$data.dialogVisible = false;
            vue.query();
            vue.$message({
              message: "提交成功",
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () {},
            });
          } else if (res.code != 401) {
            let msg = "请求失败";
            if (null != res) {
              msg = res.msg;
            }
            let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            this.$confirm(tips, "提示", {
              confirmButtonText: "好的",
              customClass: "customClass-style",
              iconClass: "",
              dangerouslyUseHTMLString: true,
              confirmButtonClass: "confirm-style",
              showCancelButton: false,
            });
          }
        })
        .catch((error) => {});
    }, //删除
    del(row) {
      let tips =
        "<i class='el-icon-warn-tip'></i>将永久删除该条记录, 是否继续?";
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "customClass-style",
        iconClass: "",
        dangerouslyUseHTMLString: true,
        confirmButtonClass: "confirm-style",
        cancelButtonClass: "cancel-style",
      })
        .then(() => {
          this.doDel(row);
        })
        .catch(() => {});
    },
    doDel(row) {
      let vue = this;
      this.postJsonRequest("/basic-info-server/airport/DelAirPort.do", row)
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            let totalPage = Math.ceil((this.totalCount - 1) / this.size);
            let currentPage =
              this.current > totalPage ? totalPage : this.current;
            this.current = currentPage < 1 ? 1 : currentPage;
            vue.query();
            vue.$message({
              message: "删除成功",
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () {},
            });
          } else if (res.code != 401) {
            let msg = "请求失败";
            if (null != res) {
              msg = res.msg;
            }
            let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            this.$confirm(tips, "提示", {
              confirmButtonText: "好的",
              customClass: "customClass-style",
              iconClass: "",
              dangerouslyUseHTMLString: true,
              confirmButtonClass: "confirm-style",
              showCancelButton: false,
            });
          }
        })
        .catch((error) => {});
    }, //分页函数
    handleSizeChange: function (val) {
      this.size = val;
      this.query();
    },
    handleCurrentChange: function (current) {
      this.current = current;
      this.query();
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid && this.$data.addFlag) {
          this.addAirport();
        } else if (valid && !this.$data.addFlag) {
          this.editAirport();
        } else {
          return false;
        }
      });
    },
  },
  watch: {
    dialogVisible: function (nval, oval) {
      if (!nval) {
        this.$data.commonForm = {};
      }
      this.defaultClearValidate();
    },
  },
};
</script>

<style scoped>
.mainCommonListContainer {
  width: 100%;
  height: 100%;
}
</style>
<style>
.adminHomeContainer
  .el-tabs
  .el-tabs__content
  #pane-airportList
  .commonDialog
  .el-dialog {
  margin-top: calc(25% - 350px) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/airport/airport.vue